import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {OrderStatus} from "../enums/OrderStatus";
import {Page} from "../interface/hashtag";
import {Order} from "../models/Order";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {OrderRequest} from "../models/orderRequest";
import {InitPaymentRequest} from "../models/payment/initPaymentRequest";
import {InitPaymentResponse} from "../models/payment/initPaymentResponse";
import {QuickOrderRequest} from "../models/quickOrderRequest";

@Injectable({
  providedIn: 'root',
})
export class OrdersService {

  private readonly ENDPOINT_URL: string = environment.apiUrl + "/orders";

  constructor(private http: HttpClient) {
  }

  updateOrderStatus(id: number, status: OrderStatus) {
    const params = {
      status: status
    }
    return this.http.put<Order>(`${this.ENDPOINT_URL}/${id}`, null, {params});
  }

  getOrders(page: number, pageSize: number, status?: OrderStatus | string, searchTerm?: string): Observable<Page<Order>> {
    const params: { [key: string]: any } = {
      page: page,
      size: pageSize,
    };

    if (status) {
      params['status'] = status;
    }
    if (searchTerm) {
      params['searchTerm'] = searchTerm;
    }
    return this.http.get<Page<Order>>(this.ENDPOINT_URL, {params});
  }

  getOrderById(orderId: number): Observable<Order> {
    return this.http.get<Order>(`${this.ENDPOINT_URL}/${orderId}`);
  }


  create(request: OrderRequest): Observable<Order> {
    return this.http.post<Order>(this.ENDPOINT_URL, request);
  }

  buyWithExistingCard(request: InitPaymentRequest): Observable<Order> {
    const url = `${this.ENDPOINT_URL}/binding`
    return this.http.post<Order>(url, request);
  }

  process(request: InitPaymentRequest): Observable<InitPaymentResponse> {
    const url = `${this.ENDPOINT_URL}/process`
    return this.http.post<InitPaymentResponse>(url, request);
  }

  quickOrder(request: QuickOrderRequest): Observable<Order> {
    const url = `${this.ENDPOINT_URL}/quick-order`
    return this.http.post<Order>(url, request)
  }

  byId(id: number): Observable<Order> {
    const url = `${this.ENDPOINT_URL}/${id}`;
    return this.http.get<Order>(url);
  }
}
